import gsap from "gsap";

const move = (element, event, duration) => {
  const radius = element.clientWidth / 2;
  gsap.to(element, {
    duration,
    x: event.clientX - radius,
    y: event.clientY - radius,
    ease: "none",
    overwrite: "auto",
  });
};

const mouse = () => {
  const large = document.querySelector(".mouse-large");
  const small = document.querySelector(".mouse-small");

  window.addEventListener("mousemove", (event) => {
    move(large, event, 5);
    move(small, event, 3);
  });
};

export default mouse;
